import { api, IApiOptions } from "../../utils/api/actions";
import { APIConstants } from "../../utils/api/constants";
import { ContestApiResponse } from "../queries/queryTypes";
import { Constants } from "./constants";
import { Filter, Page, Pages, MultipleFilters } from "./types";

export const setContest = (contest: ContestApiResponse) =>({
  type: Constants.SET_CONTEST,
  payload: contest,
});

export const setEnabledContest = (contest: ContestApiResponse) =>({
  type: Constants.SET_ENABLED_CONTEST,
  payload: contest,
});

export const setUser = (user: string) =>({
  type: Constants.SET_USER,
  payload: user,
});

export const setOpponent = (opponent: string) =>({
  type: Constants.SET_OPPONENT,
  payload: opponent,
});
export const setDate = (date: Date | null) =>({
  type: Constants.SET_DATE,
  payload: date,
});

export const setFilter = (filter: Filter | MultipleFilters , type: Constants.SET_USER_SORT | Constants.SET_PLAYER_SORT | Constants.SET_LINEUP_SORT | Constants.SET_STACK_SORT) => ({
  type,
  payload: filter,
});

export const setPageInfo = (pageInfo: Pages) => ({
  type: Constants.SET_PAGE,
  payload: pageInfo,
});

export const resetUserRoi = () => {
  return {
    type: Constants.SET_USER_NAME_ROI,
    status: APIConstants.STARTED,
    data: [],
  };
}

export const getSlates = (sport: string, site: string, date: Date | null) => {
  let options: IApiOptions = {
    method: 'GET',
    route: '',
  };
  const route = '/api/contests/getPostContestSlates';

  let dateString = date?.toDateString();

  options = {
    ...options,
    route,
    params: {
      sport,
      date: dateString,
      site,
    }
  };

  return api(
    Constants.SET_SLATES, {
    ...options,
  });
};

export const getUserRoi = (siteContestId: string, filter: Filter, pageInfo: Page, user: string, constant: Constants.SET_USER_ROI | Constants.SET_USER_NAME_ROI, headerConstant: any) => {
  let options: IApiOptions = {
    method: 'GET',
    route: '',
  };

  const route = '/api/contests/getRoiByUser';

  options = {
    ...options,
    route,
    params: {
      siteContestId,
      sortBy: filter.sortBy,
      sortOrder: filter.sortOrder,
      currentPage: pageInfo.currentPage.toString(),
      pageSize: pageInfo.pageSize.toString(),
      user,
      contestType: 'PostContest',
      includeAllUsers: true,
    }
  };

  return api(
    constant, {
    ...options,
  }, headerConstant
  );
};

export const getPlayerTabRoi = (siteContestId: string, user: string, opponent: string, filter: Filter, pageInfo: Page, constant: Constants.SET_PLAYER_ALL_ROI | Constants.SET_PLAYER_USER_ROI | Constants.SET_PLAYER_OPPONENT_ROI, headerConstant: any ) => {
  let options: IApiOptions = {
    method: 'GET',
    route: '',
    timeout: 90 * 1000
  };

  const route = '/api/contests/getRoiByPlayer';

  options = {
    ...options,
    route,
    params: {
      siteContestId,
      user,
      opponent,
      sortBy: filter.sortBy,
      sortOrder: filter.sortOrder,
      currentPage: pageInfo.currentPage.toString(),
      pageSize: pageInfo.pageSize.toString(),
      contestType: 'PostContest',
      includeAllPLayers: true,
    }
  };

  return api(
    constant, {
    ...options,
  }, headerConstant
  );
};

export const getLineupTabRoi = (siteContestId: string, user: string, filter: Filter, pageInfo: Page, constant: Constants.SET_LINEUP_ALL_ROI | Constants.SET_LINEUP_USER_ROI | Constants.SET_LINEUP_OPPONENT_ROI, headerConstant: any) => {
  let options: IApiOptions = {
    method: 'GET',
    route: '',
    timeout: 90 * 1000
  };

  const route = '/api/contests/getRoiByLineup';

  options = {
    ...options,
    route,
    params: {
      siteContestId,
      user,
      sortBy: filter.sortBy,
      sortOrder: filter.sortOrder,
      currentPage: pageInfo.currentPage.toString(),
      pageSize: pageInfo.pageSize.toString(),
      contestType: 'PostContest',
      includeAllLineups: true,
    }
  };

  return api(
    constant, {
    ...options,
  }, headerConstant
  );
};

export const getStackTabRoi = (siteContestId: string, user: string, filter: Filter, pageInfo: Page, constant: Constants.SET_STACK_ALL_ROI | Constants.SET_STACK_USER_ROI | Constants.SET_STACK_OPP_ROI, headerConstant: any, sport: string) => {
  let options: IApiOptions = {
    method: 'GET',
    route: '',
  };
  let route = '/api/contests/getRoiByStack';
  if (sport?.toLowerCase() === 'nfl') {
    route = '/api/contests/getRoiByStackNFL';
  }

  options = {
    ...options,
    route,
    params: {
      siteContestId,
      user,
      currentPage: pageInfo.currentPage.toString(),
      pageSize: pageInfo.pageSize.toString(),
      contestType: 'PostContest',
      includeAllStacks: true,
    }
  };

  return api(
    constant, {
    ...options,
  }, headerConstant
  );
};